import React from 'react'
import './styles.scss'

import Scrollchor from 'react-scrollchor'

interface ChapterNavigationI {
  content: { name: string; id: string }[]
  title?: string
  noContainer?: boolean
}

export const ChapterNavigation = ({
  content,
  title,
  noContainer
}: ChapterNavigationI) => (
  <div
    className={'chapterNavigation ' + (noContainer ? '' : 'ui text container ')}
  >
    {title && <div className='title'>{title}</div>}
    {content.map((chapter, i) => {
      return (
        <Scrollchor
          to={chapter.id}
          key={i}
          className='scroll_nav'
          onClick={() => {
            console.log('KLICK')
          }}
        >
          <div className='chapter'>
            <div className='name'>{chapter.name}</div>
            <div className='icon'>
              <i className='arrow alternate down icon' />{' '}
            </div>
          </div>
        </Scrollchor>
      )
    })}
  </div>
)
